/* ============================================================
   HORMVITA — theme runtime
   ============================================================ */
(function () {
  'use strict';
  const $  = (s, r) => (r || document).querySelector(s);
  const $$ = (s, r) => Array.prototype.slice.call((r || document).querySelectorAll(s));
  /* Shopify money_format supports several placeholders and separator styles —
     handle all of them, not just {{amount}}. */
  const money = (cents, fmt) => {
    const n = Number(cents) || 0;
    const group = (sep, dec, places) => {
      const parts = (n / 100).toFixed(places).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, sep);
      return places ? parts.join(dec) : parts[0];
    };
    const styles = {
      amount: [',', '.', 2],
      amount_no_decimals: [',', '.', 0],
      amount_with_comma_separator: ['.', ',', 2],
      amount_no_decimals_with_comma_separator: ['.', ',', 0],
      amount_with_apostrophe_separator: ["'", '.', 2],
      amount_with_space_separator: [' ', ',', 2],
      amount_no_decimals_with_space_separator: [' ', ',', 0],
      amount_with_period_and_space_separator: [' ', '.', 2]
    };
    return (fmt || '${{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/g, (m, name) => {
      const st = styles[name] || styles.amount;
      return group(st[0], st[1], st[2]);
    });
  };

  /* ---------- Scroll reveal ---------- */
  function reveal() {
    const els = $$('.rv');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) { els.forEach(e => e.classList.add('is-in')); return; }
    const io = new IntersectionObserver((ents) => {
      ents.forEach(en => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    els.forEach(e => {
      const r = e.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) { e.classList.add('rv--now', 'is-in'); return; }
      io.observe(e);
    });
  }

  /* ---------- Mobile nav ---------- */
  function nav() {
    const burger = $('[data-burger]'), drawer = $('[data-mnav]');
    if (!burger || !drawer) return;
    const closeBtn = $('[data-mnav-close]', drawer);
    const focusable = () => $$('a[href],button:not([disabled]),input,select,textarea', drawer)
      .filter(el => el.offsetParent !== null);
    const set = (open) => {
      burger.setAttribute('aria-expanded', String(open));
      drawer.setAttribute('data-open', String(open));
      if ('inert' in drawer) drawer.inert = !open;
      else drawer.setAttribute('aria-hidden', String(!open));
      document.body.style.overflow = open ? 'hidden' : '';
      if (open) { const f = closeBtn || focusable()[0]; if (f) f.focus(); }
      else if (document.activeElement && drawer.contains(document.activeElement)) burger.focus();
    };
    drawer.setAttribute('role', 'dialog');
    drawer.setAttribute('aria-modal', 'true');
    if (!drawer.getAttribute('aria-label')) drawer.setAttribute('aria-label', 'Menu');
    if (drawer.id) burger.setAttribute('aria-controls', drawer.id);
    set(false);
    burger.addEventListener('click', () => set(drawer.getAttribute('data-open') !== 'true'));
    $$('[data-mnav-close], .mnav__link', drawer).forEach(a => a.addEventListener('click', () => set(false)));
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape') { set(false); return; }
      if (e.key !== 'Tab' || drawer.getAttribute('data-open') !== 'true') return;
      const items = focusable();
      if (!items.length) return;
      const first = items[0], last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }

  /* ---------- Countdown ---------- */
  function countdown() {
    const clocks = $$('[data-countdown]').map(el => {
      const mins = parseInt(el.getAttribute('data-countdown'), 10) || 20;
      const KEY = 'hv_cd_' + (el.getAttribute('data-cd-key') || 'main');
      let end = 0;
      try { end = parseInt(sessionStorage.getItem(KEY) || '0', 10); } catch (e) {}
      if (!end || end < Date.now()) {
        end = Date.now() + mins * 60000;
        try { sessionStorage.setItem(KEY, String(end)); } catch (e) {}
      }
      return { end: end, h: $('[data-cd-h]', el), m: $('[data-cd-m]', el), s: $('[data-cd-s]', el) };
    });
    if (!clocks.length) return;
    const pad = n => String(n).padStart(2, '0');
    const tick = () => {
      clocks.forEach(c => {
        const d = Math.max(0, c.end - Date.now()) / 1000 | 0;
        if (c.h) c.h.textContent = pad(d / 3600 | 0);
        if (c.m) c.m.textContent = pad((d % 3600) / 60 | 0);
        if (c.s) c.s.textContent = pad(d % 60);
      });
    };
    tick();
    const t = setInterval(tick, 1000);
    window.addEventListener('pagehide', () => clearInterval(t));
  }

  /* ---------- Toast ---------- */
  let toastEl;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      toastEl.innerHTML = '<svg viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"/></svg><span></span>';
      document.body.appendChild(toastEl);
    }
    $('span', toastEl).textContent = msg;
    toastEl.setAttribute('data-show', 'true');
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(() => toastEl.setAttribute('data-show', 'false'), 2600);
  }

  /* ---------- Cart ---------- */
  async function addToCart(id, qty, selling_plan) {
    const body = { items: [{ id: Number(id), quantity: Number(qty) || 1 }] };
    if (selling_plan) body.items[0].selling_plan = Number(selling_plan);
    const r = await fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    });
    if (!r.ok) { const e = await r.json().catch(() => ({})); throw new Error(e.description || 'Could not add to cart'); }
    return r.json();
  }
  async function refreshCount() {
    try {
      const r = await fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
      const c = await r.json();
      $$('[data-cart-count]').forEach(el => {
        el.textContent = c.item_count;
        el.style.display = c.item_count > 0 ? '' : 'none';
      });
    } catch (e) {}
  }

  /* ---------- Product form ---------- */
  /* Two independent option groups live in one form:
     [data-vgroup="variant"] (which bundle) and [data-vgroup="plan"] (one-time vs subscribe).
     A single {id, plan} state recomputes price, selling_plan and availability from
     the server-rendered [data-variant-map], so the two groups can't clobber each other. */
  function productForm() {
    $$('[data-product-form]').forEach(form => {
      const idInput = $('[name="id"]', form);
      const btn = $('[data-atc]', form);
      const scope = form.closest('[data-product-root]') || document;
      const priceNow = $('[data-price-now]', scope);
      const priceWas = $('[data-price-was]', scope);
      const stickyPrice = $('[data-sticky-price]');
      const stickyWas = $('[data-sticky-was]');
      const fmt = form.getAttribute('data-money-format') || '${{amount}}';

      let map = {};
      const mapEl = $('[data-variant-map]', form);
      if (mapEl) { try { map = JSON.parse(mapEl.textContent) || {}; } catch (e) { map = {}; } }

      const state = { id: idInput ? String(idInput.value) : '', plan: 'onetime' };
      let submitting = false;

      const apply = () => {
        const v = map[state.id];
        if (!v) return;
        if (!v.plan && state.plan === 'sub') state.plan = 'onetime';
        const sub = state.plan === 'sub' && !!v.plan;

        if (idInput) idInput.value = state.id;
        let spInput = $('[name="selling_plan"]', form);
        if (sub) {
          if (!spInput) { spInput = document.createElement('input'); spInput.type = 'hidden'; spInput.name = 'selling_plan'; form.appendChild(spInput); }
          spInput.value = v.plan.id;
        } else if (spInput) { spInput.remove(); }

        const price = sub ? v.plan.price : v.price;
        const compare = sub ? v.price : v.compare;
        if (priceNow) priceNow.textContent = money(price, fmt);
        if (priceWas) {
          if (compare && compare > price) { priceWas.textContent = money(compare, fmt); priceWas.style.display = ''; }
          else priceWas.style.display = 'none';
        }
        if (stickyPrice) stickyPrice.textContent = money(price, fmt);
        if (stickyWas) {
          if (compare && compare > price) { stickyWas.textContent = money(compare, fmt); stickyWas.style.display = ''; }
          else stickyWas.style.display = 'none';
        }

        /* subscribe / one-time rows always describe the CURRENTLY selected variant */
        const subRow = $('[data-vgroup="plan"][data-plan="sub"]', form);
        if (subRow) {
          subRow.hidden = !v.plan;
          if (v.plan) {
            const pEl = $('[data-plan-price]', subRow); if (pEl) pEl.textContent = money(v.plan.price, fmt);
            const cEl = $('[data-plan-compare]', subRow); if (cEl) cEl.textContent = money(v.price, fmt);
            const nEl = $('[data-plan-name]', subRow); if (nEl && v.plan.name) nEl.textContent = v.plan.name + ' · cancel anytime';
          }
        }
        const otRow = $('[data-vgroup="plan"][data-plan="onetime"]', form);
        if (otRow) { const pEl = $('[data-plan-price]', otRow); if (pEl) pEl.textContent = money(v.price, fmt); }

        $$('[data-vgroup="variant"]', form).forEach(o => {
          const on = o.getAttribute('data-variant-id') === state.id;
          o.setAttribute('data-sel', String(on));
          const inp = $('input', o); if (inp) inp.checked = on;
        });
        $$('[data-vgroup="plan"]', form).forEach(o => {
          const on = o.getAttribute('data-plan') === state.plan;
          o.setAttribute('data-sel', String(on));
          const inp = $('input', o); if (inp) inp.checked = on;
        });

        if (btn) {
          btn.disabled = submitting || !v.available;
          const l = $('[data-atc-label]', btn);
          if (l) l.textContent = v.available ? (btn.getAttribute('data-label') || 'Add to cart') : 'Sold out';
        }
      };

      const pick = (opt) => {
        if (!opt || !form.contains(opt)) return;
        if (opt.getAttribute('data-vgroup') === 'plan') state.plan = opt.getAttribute('data-plan') || 'onetime';
        else if (opt.getAttribute('data-variant-id')) state.id = opt.getAttribute('data-variant-id');
        apply();
      };
      form.addEventListener('change', e => pick(e.target.closest('[data-vopt]')));
      form.addEventListener('click', e => pick(e.target.closest('[data-vopt]')));
      if (map[state.id]) apply();

      /* Qty */
      const qtyIn = $('[data-qty-input]', form);
      $$('[data-qty]', form).forEach(b => b.addEventListener('click', () => {
        if (!qtyIn) return;
        const d = b.getAttribute('data-qty') === 'up' ? 1 : -1;
        qtyIn.value = Math.max(1, (parseInt(qtyIn.value, 10) || 1) + d);
      }));

      /* Submit */
      form.addEventListener('submit', async (e) => {
        if (form.getAttribute('data-ajax') === 'false') return;
        e.preventDefault();
        if (!btn || submitting) return;
        submitting = true;
        const label = $('[data-atc-label]', btn);
        const prev = label ? label.textContent : '';
        btn.disabled = true; if (label) label.textContent = 'Adding…';
        try {
          const sp = $('[name="selling_plan"]', form);
          await addToCart(idInput.value, qtyIn ? qtyIn.value : 1, sp ? sp.value : null);
          await refreshCount();
          if (label) label.textContent = 'Added ✓';
          toast('Added to your cart');
          if (form.getAttribute('data-redirect') === 'checkout') { window.location.href = '/checkout'; return; }
          if (form.getAttribute('data-redirect') === 'cart') { window.location.href = '/cart'; return; }
          setTimeout(() => { submitting = false; if (label) label.textContent = prev; apply(); if (!map[state.id]) btn.disabled = false; }, 1400);
        } catch (err) {
          toast(err.message || 'Something went wrong');
          submitting = false;
          if (label) label.textContent = prev;
          apply();
          if (!map[state.id]) btn.disabled = false;
        }
      });
    });
  }

  /* ---------- Gallery ---------- */
  function gallery() {
    $$('[data-gallery]').forEach(g => {
      const imgs = $$('[data-gal-img]', g), thumbs = $$('[data-gal-thumb]', g);
      const go = i => {
        imgs.forEach((im, k) => {
          im.setAttribute('data-active', String(k === i));
          im.setAttribute('aria-hidden', String(k !== i));
        });
        thumbs.forEach((t, k) => t.setAttribute('aria-current', String(k === i)));
      };
      thumbs.forEach((t, i) => t.addEventListener('click', () => go(i)));
      const mainEl = $('[data-gal-main]', g);
      if (mainEl && imgs.length > 1) {
        mainEl.setAttribute('tabindex', '0');
        mainEl.setAttribute('role', 'group');
        mainEl.setAttribute('aria-roledescription', 'carousel');
        mainEl.setAttribute('aria-label', 'Product images');
        mainEl.addEventListener('keydown', e => {
          const d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
          if (!d) return;
          e.preventDefault();
          let cur = imgs.findIndex(im => im.getAttribute('data-active') === 'true');
          go((cur + d + imgs.length) % imgs.length);
        });
      }
      let x0 = null;
      const main = $('[data-gal-main]', g);
      if (main) {
        main.addEventListener('touchstart', e => { x0 = e.touches[0].clientX; }, { passive: true });
        main.addEventListener('touchend', e => {
          if (x0 === null) return;
          const dx = e.changedTouches[0].clientX - x0; x0 = null;
          if (Math.abs(dx) < 40) return;
          let cur = imgs.findIndex(im => im.getAttribute('data-active') === 'true');
          cur = (cur + (dx < 0 ? 1 : -1) + imgs.length) % imgs.length;
          go(cur);
        }, { passive: true });
      }
    });
  }

  /* ---------- Sticky ATC ---------- */
  function stickyAtc() {
    const bar = $('[data-sticky-atc]'); if (!bar) return;
    const anchor = $('[data-atc-anchor]');
    const purchaseButton = anchor ? $('[data-atc]', anchor) : $('[data-product-form] [data-atc]');
    const btn = $('[data-sticky-buy]', bar);
    const setVisible = (on) => {
      bar.setAttribute('data-show', String(on));
      bar.setAttribute('aria-hidden', String(!on));
      bar.inert = !on;
      if (btn) btn.tabIndex = on ? 0 : -1;
    };
    const update = () => setVisible(Boolean(purchaseButton && purchaseButton.getClientRects().length && purchaseButton.getBoundingClientRect().bottom <= 0));
    let scheduled = false;
    const requestUpdate = () => {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(() => { scheduled = false; update(); });
    };
    update();
    // A scroll can jump from below to above without changing intersection state.
    // Keep scroll/resize checks as well as the observer for layout changes.
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    window.addEventListener('pageshow', requestUpdate);
    if (purchaseButton && 'IntersectionObserver' in window) {
      new IntersectionObserver(requestUpdate, { threshold: 0 }).observe(purchaseButton);
    }
    if (btn) {
      btn.setAttribute('type', 'button');
      btn.addEventListener('click', e => {
        e.preventDefault();
        const selection = anchor && $('[data-vgroup="variant"][data-sel="true"]', anchor);
        const target = selection || purchaseButton || anchor;
        if (!target) return;
        const focusTarget = selection ? $('input:not([disabled])', selection) : purchaseButton;
        const reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        target.scrollIntoView({ behavior: reducedMotion ? 'instant' : 'smooth', block: 'center' });
        if (focusTarget) focusTarget.focus({ preventScroll: true });
        setVisible(false);
      });
    }
  }

  /* ---------- Offer tabs (one-time / subscribe) ---------- */
  function offerTabs() {
    $$('[data-tabs]').forEach((root, ri) => {
      const btns = $$('[data-tab]', root), panes = $$('[data-pane]', root);
      if (!btns.length) return;
      btns.forEach((b, i) => {
        const k = b.getAttribute('data-tab');
        const pane = panes.find(p => p.getAttribute('data-pane') === k);
        b.id = b.id || 'tab-' + ri + '-' + i;
        b.setAttribute('type', 'button');
        if (pane) {
          pane.id = pane.id || 'pane-' + ri + '-' + i;
          pane.setAttribute('role', 'tabpanel');
          pane.setAttribute('aria-labelledby', b.id);
          b.setAttribute('aria-controls', pane.id);
        }
      });
      const select = (b) => {
        const k = b.getAttribute('data-tab');
        btns.forEach(x => {
          const on = x === b;
          x.setAttribute('aria-selected', String(on));
          x.tabIndex = on ? 0 : -1;
        });
        panes.forEach(p => { p.hidden = p.getAttribute('data-pane') !== k; });
        const vis = panes.find(p => !p.hidden);
        if (vis) {
          const best = vis.querySelector('[data-bundle][data-best=true]:not([data-available=false])') || vis.querySelector('[data-bundle]:not([data-available=false])');
          if (best) best.click();
          else {
            const cta = $('[data-bundle-cta]', root);
            if (cta) { cta.disabled = true; cta.removeAttribute('data-variant-id'); }
          }
        }
      };
      btns.forEach(b => b.addEventListener('click', () => select(b)));
      btns.forEach((b, i) => b.addEventListener('keydown', e => {
        const d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!d) return;
        e.preventDefault();
        const nb = btns[(i + d + btns.length) % btns.length];
        nb.focus(); select(nb);
      }));
      const cur = btns.find(b => b.getAttribute('aria-selected') === 'true') || btns[0];
      btns.forEach(x => { x.tabIndex = x === cur ? 0 : -1; });
    });
  }

  /* ---------- Bundle cards (homepage offer) ---------- */
  function bundleCards() {
    $$('[data-bundles]').forEach(root => {
      const cards = $$('[data-bundle]', root);
      let submitting = false;
      const available = card => card.getAttribute('data-available') !== 'false';
      const visibleCards = () => cards.filter(c => available(c) && !c.closest('[hidden]'));
      const setSel = card => {
        if (!card || !available(card)) return;
        cards.forEach(c => {
          c.setAttribute('data-sel', String(c === card));
          c.setAttribute('aria-checked', String(c === card));
          c.tabIndex = c === card ? 0 : -1;
        });
        const cta = $('[data-bundle-cta]', root);
        if (cta) {
          cta.disabled = submitting;
          cta.setAttribute('data-variant-id', card.getAttribute('data-variant-id') || '');
          cta.setAttribute('data-selling-plan', card.getAttribute('data-selling-plan') || '');
        }
      };
      cards.forEach(c => {
        c.setAttribute('role', 'radio');
        c.setAttribute('aria-disabled', String(!available(c)));
        c.setAttribute('aria-checked', 'false');
        c.setAttribute('aria-label', [$('.bnd__title', c), $('.bnd__price', c)].filter(Boolean).map(el => el.textContent.trim()).join(', '));
        c.tabIndex = -1;
        c.addEventListener('click', () => setSel(c));
        c.addEventListener('keydown', e => {
          if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); setSel(c); return; }
          const d = ['ArrowRight','ArrowDown'].includes(e.key) ? 1 : ['ArrowLeft','ArrowUp'].includes(e.key) ? -1 : 0;
          if (!d) return;
          e.preventDefault();
          const active = visibleCards();
          if (!active.length) return;
          const next = active[(active.indexOf(c) + d + active.length) % active.length];
          setSel(next); next.focus();
        });
      });
      const visible = visibleCards();
      const preset = visible.find(c => c.getAttribute('data-best') === 'true') || visible[0];
      if (preset) setSel(preset);
      const cta = $('[data-bundle-cta]', root);
      if (cta) cta.disabled = !preset;
      if (cta) cta.addEventListener('click', async (e) => {
        const id = cta.getAttribute('data-variant-id');
        if (!id || submitting) return;
        e.preventDefault();
        submitting = true; cta.disabled = true;
        const lbl = $('[data-atc-label]', cta), prev = lbl ? lbl.textContent : '';
        if (lbl) lbl.textContent = 'Adding…';
        try {
          await addToCart(id, 1, cta.getAttribute('data-selling-plan') || null);
          window.location.href = '/checkout';
        } catch (err) {
          submitting = false;
          cta.disabled = !cta.getAttribute('data-variant-id');
          toast(err.message);
          if (lbl) lbl.textContent = prev;
        }
      });
    });
  }

  /* ---------- QUIZ ---------- */
  function quiz() {
    const root = $('[data-quiz]'); if (!root) return;
    const steps = $$('[data-qstep]', root);
    const fill = $('[data-quiz-fill]', root);
    const bar = $('.quiz__bar', root);
    const curEl = $('[data-quiz-cur]', root);
    const tot = $('[data-quiz-total]', root);
    const backBtns = $$('[data-quiz-back]', root);
    const questions = steps.filter(s => s.getAttribute('data-qstep') === 'q');
    const REDUCE = window.matchMedia ? matchMedia('(prefers-reduced-motion: reduce)').matches : false;
    const SKEY = 'hv_quiz_state';
    const MAXAGE = 2 * 60 * 60 * 1000;
    let i = 0;
    let answers = {};
    let timers = [];
    let rendered = false;

    const type = k => (steps[k] ? steps[k].getAttribute('data-qstep') : '');
    const clearTimers = () => { timers.forEach(clearTimeout); timers = []; };

    if (tot) tot.textContent = questions.length;

    steps.forEach(step => {
      if (step.getAttribute('data-qstep') !== 'q') return;
      const wrap = $('.qopts', step);
      if (!wrap) return;
      const multi = step.getAttribute('data-multi') === 'true';
      const h = $('h2', step);
      if (!multi) {
        wrap.setAttribute('role', 'radiogroup');
        if (h) { h.id = h.id || 'q-' + (step.getAttribute('data-qkey') || Math.random().toString(36).slice(2)); wrap.setAttribute('aria-labelledby', h.id); }
      } else if (h) {
        wrap.setAttribute('role', 'group');
        h.id = h.id || 'q-' + (step.getAttribute('data-qkey') || Math.random().toString(36).slice(2));
        wrap.setAttribute('aria-labelledby', h.id);
      }
      $$('[data-qopt]', step).forEach(o => {
        if (multi) o.setAttribute('aria-pressed', o.getAttribute('data-sel') === 'true' ? 'true' : 'false');
        else { o.setAttribute('role', 'radio'); o.setAttribute('aria-checked', o.getAttribute('data-sel') === 'true' ? 'true' : 'false'); }
      });
    });

    /* ---- resume a half-finished quiz after a refresh ---- */
    const save = () => {
      try { sessionStorage.setItem(SKEY, JSON.stringify({ i: i, a: answers, t: Date.now() })); } catch (e) {}
    };
    const restore = () => {
      let st = null;
      try { st = JSON.parse(sessionStorage.getItem(SKEY) || 'null'); } catch (e) {}
      if (!st || typeof st.i !== 'number' || st.i <= 0 || st.i >= steps.length) return;
      if (!st.t || Date.now() - st.t > MAXAGE) { try { sessionStorage.removeItem(SKEY); } catch (e) {} return; }
      answers = st.a || {};
      let j = st.i;
      while (j > 0 && type(j) === 'loading') j--;   /* never resume onto a transient screen */
      i = j;
      steps.forEach(step => {
        const key = step.getAttribute('data-qkey');
        if (!key || answers[key] == null) return;
        const v = answers[key];
        if (step.getAttribute('data-measure') === 'true') {
          $$('[data-qinput]', step).forEach(inp => {
            const k = inp.getAttribute('data-qinput');
            if (v && v[k] != null) inp.value = v[k];
          });
        } else {
          const list = Array.isArray(v) ? v : [v];
          $$('[data-qopt]', step).forEach(o => {
            const selected = String(list.indexOf(o.getAttribute('data-qopt')) > -1);
            o.setAttribute('data-sel', selected);
            o.setAttribute(step.getAttribute('data-multi') === 'true' ? 'aria-pressed' : 'aria-checked', selected);
          });
        }
      });
      const em = $('[data-qemail]', root);
      if (em && answers.email) em.value = answers.email;
    };

    /* ---- scoring: every option carries its own weight from the section schema ---- */
    const weightOf = o => parseFloat(o.getAttribute('data-weight')) || 0;
    /* symptom-style answers only: the multi-select questions, minus "None of these" (weight 0) */
    const pickedWeighted = () => {
      const out = [];
      steps.forEach(step => {
        if (step.getAttribute('data-multi') !== 'true') return;
        $$('[data-qopt][data-sel=true]', step).forEach(o => { if (weightOf(o) > 0) out.push(o); });
      });
      return out;
    };
    function computeScore() {
      let sum = 0;
      steps.forEach(step => {
        if (step.getAttribute('data-qstep') !== 'q') return;
        $$('[data-qopt][data-sel=true]', step).forEach(o => { sum += weightOf(o); });
      });
      return Math.max(0, Math.min(99, Math.round(sum)));
    }
    function renderTags() {
      const wrap = $('[data-quiz-tags]', root); if (!wrap) return;
      const seen = {}, tags = [];
      pickedWeighted().forEach(o => {
        const el = $('[data-qlabel]', o);
        let t = (el ? el.textContent : (o.getAttribute('data-qopt') || '')).trim();
        t = t.replace(/^[^\w(]+/, '').trim();
        const k = t.toLowerCase();
        if (!t || seen[k]) return;
        seen[k] = 1; tags.push(t);
      });
      wrap.textContent = '';
      tags.slice(0, 6).forEach(t => {
        const s = document.createElement('span');
        s.className = 'pill'; s.textContent = t;
        wrap.appendChild(s);
      });
    }

    const render = () => {
      clearTimers();
      steps.forEach((s, k) => s.setAttribute('data-active', String(k === i)));
      const qIdx = questions.indexOf(steps[i]);
      const pct = Math.max(4, Math.round(((i + 1) / steps.length) * 100));
      if (fill) fill.style.width = pct + '%';
      if (bar) {
        bar.setAttribute('role', 'progressbar');
        bar.setAttribute('aria-label', 'Quiz progress');
        bar.setAttribute('aria-valuemin', '0');
        bar.setAttribute('aria-valuemax', '100');
        bar.setAttribute('aria-valuenow', String(pct));
      }
      if (curEl && qIdx >= 0) curEl.textContent = qIdx + 1;
      const reachedQuestions = questions.filter(q => steps.indexOf(q) <= i).length;
      const chapter = type(i) === 'result' || i > steps.indexOf(questions[questions.length - 1]) ? 2 : reachedQuestions > Math.ceil(questions.length / 2) ? 1 : 0;
      $$('[data-quiz-chapter]', root).forEach(el => el.setAttribute('data-current', String(Number(el.getAttribute('data-quiz-chapter')) === chapter)));
      const showBack = i > 0 && type(i) !== 'result' && type(i) !== 'loading';
      backBtns.forEach(b => { b.style.visibility = showBack ? 'visible' : 'hidden'; });
      const meta = $('[data-quiz-meta]', root);
      if (meta) meta.style.visibility = qIdx >= 0 ? 'visible' : 'hidden';
      if (rendered) {
        root.scrollIntoView({ behavior: REDUCE ? 'auto' : 'smooth', block: 'start' });
        const heading = $('h2', steps[i]);
        if (heading) { heading.tabIndex = -1; heading.focus({ preventScroll: true }); }
      }
      rendered = true;
      fillWidgets(steps[i]);
      syncNext(steps[i]);
      save();
      if (type(i) === 'loading') runLoading(i);
      if (type(i) === 'result') showResult();
    };

    function fillWidgets(step) {
      if (!step) return;
      const w = answers['weight'] || {}, h = answers['height'] || {};
      const cur = parseFloat(w['current-weight']) || 0, goal = parseFloat(w['goal-weight']) || 0;
      const set = (sel, v) => { const el = $(sel, step); if (el) el.textContent = v; };
      if ($('[data-fill=chart]', step)) {
        set('[data-ch-cur]', cur ? cur + ' lb' : '—');
        set('[data-ch-goal]', goal ? goal + ' lb' : '—');
        set('[data-svg-cur]', cur ? cur + ' lb' : '');
        set('[data-svg-goal]', goal ? goal + ' lb' : '');
        if (cur && goal) {
          set('[data-svg-m1]', Math.round(cur - (cur - goal) * 0.4) + ' lb');
          set('[data-svg-m2]', Math.round(cur - (cur - goal) * 0.75) + ' lb');
        }
      }
      if ($('[data-fill=summary]', step)) {
        const inches = (parseFloat(h['feet']) || 0) * 12 + (parseFloat(h['inches']) || 0);
        const bmi = inches && cur ? 703 * cur / (inches * inches) : 0;
        set('[data-sm-bmi]', bmi ? bmi.toFixed(1) : '—');
        const dot = $('[data-sm-dot]', step);
        if (dot && bmi) dot.style.left = (Math.min(Math.max((bmi - 15) / 25, 0), 1) * 100) + '%';
        const load = pickedWeighted().length;
        set('[data-sm-load]', load || '—');
        set('[data-sm-chance]', Math.min(94, Math.round(35 + computeScore() * 0.6)) + '%');
      }
    }

    /* ---- the calculating screen only ticks its list and advances ---- */
    function runLoading(at) {
      const items = $$('.qloading__list li', steps[at]);
      items.forEach(li => li.classList.remove('on'));
      items.forEach((li, k) => timers.push(setTimeout(() => li.classList.add('on'), 500 + k * 620)));
      timers.push(setTimeout(() => {
        if (i !== at) return;               /* user pressed Back — don't yank them forward */
        i++; render();
      }, 500 + items.length * 620 + 700));
    }

    /* ---- the score animates when the result is actually on screen ---- */
    function showResult() {
      const score = computeScore();
      const circle = $('[data-quiz-ring]', root);
      const ring = $('[data-quiz-ringval]', root);
      if (circle) {
        const len = 2 * Math.PI * 62;
        circle.style.transition = 'none';
        circle.style.strokeDasharray = len;
        circle.style.strokeDashoffset = len;
        if (REDUCE) circle.style.strokeDashoffset = len * (1 - score / 100);
        else requestAnimationFrame(() => requestAnimationFrame(() => {
          circle.style.transition = 'stroke-dashoffset 1.2s cubic-bezier(.16,1,.3,1)';
          circle.style.strokeDashoffset = len * (1 - score / 100);
        }));
      }
      if (ring) {
        clearInterval(ring._t);
        if (REDUCE) ring.textContent = score + '%';
        else {
          let n = 0;
          ring._t = setInterval(() => {
            n = Math.min(score, n + 2);
            ring.textContent = n + '%';
            if (n >= score) clearInterval(ring._t);
          }, 22);
        }
      }
      renderTags();
      completeQuiz();
    }

    /* --- lead capture -------------------------------------------------- */
    const quizProps = () => {
      const h = answers.height || {}, w = answers.weight || {};
      const cur = parseFloat(w['current-weight']) || 0;
      const goal = parseFloat(w['goal-weight']) || 0;
      const inches = (parseFloat(h.feet) || 0) * 12 + (parseFloat(h.inches) || 0);
      const props = {
        quiz_score: computeScore(),
        quiz_symptoms: pickedWeighted().map(o => {
          const el = $('[data-qlabel]', o);
          return (el ? el.textContent : o.getAttribute('data-qopt') || '').trim();
        }),
        custom_source: 'Hormone quiz'
      };
      if (cur) props.current_weight_lb = cur;
      if (goal) props.goal_weight_lb = goal;
      if (cur && goal) props.weight_to_goal_lb = Math.max(0, Math.round(cur - goal));
      if (inches && cur) props.bmi = Math.round(703 * cur / (inches * inches) * 10) / 10;
      Object.keys(answers).forEach(k => {
        const v = answers[k];
        if (k === 'email' || v == null) return;
        if (typeof v === 'string' || Array.isArray(v)) props['quiz_' + k] = v;
      });
      return props;
    };
    function captureLead(email) {
      const props = quizProps();
      if (!KL.on()) {
        try {
          const fd = new FormData();
          fd.append('form_type', 'customer'); fd.append('utf8', '✓');
          fd.append('contact[email]', email); fd.append('contact[tags]', 'quiz');
          fetch('/contact', { method: 'POST', body: fd }).catch(() => {});
        } catch (e) {}
        return;
      }
      KL.subscribe(email, props, (window.HV_CFG || {}).quizList || null)
        .then(() => KL.track('Quiz Email Captured', email, props))
        .catch(err => console.warn('[hormvita] lead capture failed:', err.message));
    }
    function completeQuiz() {
      const email = answers.email;
      if (!email || !KL.on() || root._completed) return;
      root._completed = true;
      const props = quizProps();
      KL.track('Completed Quiz', email, props)
        .catch(err => console.warn('[hormvita] completion event failed:', err.message));
    }

    const next = () => { if (i < steps.length - 1) { i++; render(); } };

    const stepValid = (step) => {
      if (!step) return true;
      if (step.getAttribute('data-measure') === 'true') {
        return $$('[data-qinput]', step).every(inp => {
          if (String(inp.value).trim() === '') return false;
          const v = parseFloat(inp.value);
          if (isNaN(v)) return false;
          const min = parseFloat(inp.getAttribute('data-qmin'));
          return v >= (isNaN(min) ? 0 : min);
        });
      }
      if (step.getAttribute('data-qstep') === 'q' && step.getAttribute('data-multi') === 'true')
        return !!step.querySelector('[data-qopt][data-sel=true]');
      return true;
    };
    const syncNext = (step) => {
      if (!step) return;
      const gated = step.getAttribute('data-multi') === 'true' || step.getAttribute('data-measure') === 'true';
      const btn = step.querySelector('[data-quiz-next]');
      if (!gated || !btn) return;
      btn.setAttribute('aria-disabled', stepValid(step) ? 'false' : 'true');
    };
    const collectMeasure = (step) => {
      const key = step.getAttribute('data-qkey');
      if (!key) return;
      const vals = {};
      $$('[data-qinput]', step).forEach(inp => { vals[inp.getAttribute('data-qinput')] = inp.value; });
      answers[key] = vals;
    };
    root.addEventListener('input', (e) => {
      if (!e.target.matches('[data-qinput]')) return;
      const step = e.target.closest('[data-qstep]');
      syncNext(step);
      if (step && step.getAttribute('data-measure') === 'true') { collectMeasure(step); save(); }
    });

    $$('[data-qopt]', root).forEach(opt => {
      opt.addEventListener('click', () => {
        const step = opt.closest('[data-qstep]');
        const key = step.getAttribute('data-qkey') || ('q' + i);
        const multi = step.getAttribute('data-multi') === 'true';
        if (multi) {
          opt.setAttribute('data-sel', opt.getAttribute('data-sel') === 'true' ? 'false' : 'true');
          opt.setAttribute('aria-pressed', opt.getAttribute('data-sel'));
          answers[key] = $$('[data-qopt][data-sel=true]', step).map(o => o.getAttribute('data-qopt'));
          syncNext(step);
          save();
          return;
        }
        $$('[data-qopt]', step).forEach(o => { o.setAttribute('data-sel', 'false'); o.setAttribute('aria-checked', 'false'); });
        opt.setAttribute('data-sel', 'true');
        opt.setAttribute('aria-checked', 'true');
        answers[key] = opt.getAttribute('data-qopt');
        save();
        clearTimers();
        timers.push(setTimeout(next, 230));
      });
    });

    $$('[data-quiz-next]', root).forEach(b => b.addEventListener('click', () => {
      const step = b.closest('[data-qstep]');
      if (!stepValid(step)) {
        toast(step && step.getAttribute('data-measure') === 'true' ? 'Please fill in both fields' : 'Select at least one option');
        return;
      }
      if (step && step.getAttribute('data-qstep') === 'email') {
        const em = $('[data-qemail]', step);
        if (!em || !em.value || !/.+@.+\..+/.test(em.value)) {
          toast('Enter your email to continue');
          if (em) em.focus();
          return;
        }
        answers.email = em.value;
        try { localStorage.setItem('hv_quiz_email', em.value); } catch (e) {}
        captureLead(em.value);
      }
      if (step && step.getAttribute('data-measure') === 'true') collectMeasure(step);
      next();
    }));

    backBtns.forEach(b => b.addEventListener('click', () => {
      let j = i - 1;
      while (j > 0 && type(j) === 'loading') j--;   /* skip the calculating screen */
      if (j >= 0 && j !== i) { i = j; render(); }
    }));

    /* result-screen email form — AJAX so it never reloads and resets the quiz */
    const ef = $('[data-quiz-email]', root);
    if (ef) ef.addEventListener('submit', async (e) => {
      e.preventDefault();
      const em = $('input[type=email]', ef);
      const sb = $('button[type=submit]', ef);
      if (!em || !/.+@.+\..+/.test(em.value)) { toast('Enter a valid email'); if (em) em.focus(); return; }
      const prev = sb ? sb.textContent : '';
      if (sb) { sb.disabled = true; sb.textContent = 'Sending…'; }
      try { localStorage.setItem('hv_quiz', JSON.stringify(answers)); } catch (err) {}
      try {
        const r = await fetch(ef.action || '/contact', { method: 'POST', body: new FormData(ef) });
        if (!r.ok && !r.redirected) throw new Error('bad response');
        toast('Sent — check your inbox');
        ef.reset();
      } catch (err) {
        toast('Could not send — please try again');
      }
      if (sb) { sb.disabled = false; sb.textContent = prev; }
    });

    window.HV = window.HV || {};
    window.HV.quiz = { score: computeScore, answers: () => answers, step: () => i };

    restore();
    render();
  }

  /* ---------- Klaviyo (public client APIs — site ID only, no secrets) ---------- */
  const KL = (function () {
    const key = (window.HV_CFG || {}).klaviyo || '';
    const on = () => !!key;
    const post = async (path, payload) => {
      const r = await fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + encodeURIComponent(key), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: '2025-07-15' },
        body: JSON.stringify(payload)
      });
      if (!r.ok && r.status !== 202) {
        const txt = await r.text().catch(() => '');
        throw new Error('Klaviyo ' + r.status + ' ' + txt.slice(0, 200));
      }
      return true;
    };
    const subscribe = (email, props, listId) => {
      if (!on()) return Promise.reject(new Error('no key'));
      const attrs = {
        custom_source: (props && props.custom_source) || 'Website',
        profile: { data: { type: 'profile', attributes: { email: email, properties: props || {} } } }
      };
      const payload = { data: { type: 'subscription', attributes: attrs } };
      if (listId) payload.data.relationships = { list: { data: { type: 'list', id: listId } } };
      return post('subscriptions', payload);
    };
    const track = (metric, email, props) => {
      if (!on()) return Promise.reject(new Error('no key'));
      return post('events', {
        data: {
          type: 'event',
          attributes: {
            properties: props || {},
            metric: { data: { type: 'metric', attributes: { name: metric } } },
            profile: { data: { type: 'profile', attributes: { email: email } } }
          }
        }
      });
    };
    return { on, subscribe, track };
  })();

  /* ---------- Newsletter signup ---------- */
  function newsletter() {
    $$('[data-newsletter]').forEach(form => {
      form.addEventListener('submit', async (e) => {
        const input = $('input[type=email]', form);
        if (!input || !/.+@.+\..+/.test(input.value)) return;   /* let the browser show its own error */
        if (!KL.on()) return;                                    /* fall back to the Shopify POST */
        e.preventDefault();
        const btn = $('button[type=submit]', form);
        const prev = btn ? btn.textContent : '';
        if (btn) { btn.disabled = true; btn.textContent = 'Joining…'; }
        try {
          await KL.subscribe(input.value, { custom_source: 'Footer newsletter' }, (window.HV_CFG || {}).newsList || null);
          toast('You are on the list');
          form.reset();
        } catch (err) {
          console.warn('[hormvita] newsletter signup failed:', err.message);
          toast('Could not sign you up — please try again');
        }
        if (btn) { btn.disabled = false; btn.textContent = prev; }
      });
    });
  }

  /* ---------- Keep paid-traffic attribution across internal hops ---------- */
  function utmPassthrough() {
    const qs = new URLSearchParams(location.search);
    const carry = [];
    qs.forEach((v, k) => { if (/^(utm_|gclid|fbclid|ttclid|msclkid)/i.test(k)) carry.push([k, v]); });
    if (!carry.length) return;
    $$('a[href]').forEach(a => {
      let u;
      try { u = new URL(a.href, location.href); } catch (e) { return; }
      if (u.origin !== location.origin) return;
      if (/^(mailto|tel):/i.test(a.getAttribute('href') || '')) return;
      carry.forEach(([k, v]) => { if (!u.searchParams.has(k)) u.searchParams.set(k, v); });
      a.href = u.toString();
    });
  }

  /* ---------- Init ---------- */
  function init() {
    reveal(); nav(); countdown(); productForm(); gallery(); stickyAtc();
    offerTabs(); bundleCards(); quiz(); utmPassthrough(); newsletter();
    window.addEventListener('pageshow', e => { if (e.persisted) refreshCount(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  window.HV = Object.assign(window.HV || {}, { addToCart, refreshCount, toast, money });
})();
